module.exports = __webpack_public_path__ + "static/media/explain-content@2x.1ca870e5.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_31/imgs/explain-content@2x.png
// module id = 1037
// module chunks = 0